"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResearchClient = createResearchClient;
const util_typescript_1 = require("@varos/util-typescript");
const record_1 = require("./record");
function createResearchClient(init, enhancer) {
    let enhancers = enhancer ? [enhancer] : [];
    enhancers = [...enhancers];
    return _create({
        ...init,
        logger: init.logger ?? console,
    }, (0, util_typescript_1.compose)(...enhancers));
}
function _create(config, enhancer) {
    if (enhancer) {
        return enhancer(_create)(config);
    }
    const baseConfig = {
        client: config.client,
        logger: config.logger ?? console,
    };
    return {
        record: (0, record_1.createRecordClient)(baseConfig),
    };
}
//# sourceMappingURL=clientSdkProvider.js.map